/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) SystemMaintenanceScheduleIcon component.
 */
export const SystemMaintenanceScheduleIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
      <path d="M14.9137 12.4752L17.4536 15.0151C17.5608 15.1223 17.7177 15.1602 17.8654 15.1262C19.1416 14.833 20.5508 15.2068 21.4605 16.2235C22.2909 17.1518 22.5016 18.3488 22.1289 19.4062C22.0374 19.6658 21.7093 19.7099 21.5174 19.5132C21.5163 19.5121 21.5155 19.5114 21.5145 19.5103C21.4869 19.4822 21.0219 19.0092 20.4856 18.4566C20.2909 18.256 19.9694 18.2531 19.7717 18.4508L18.4814 19.7411C18.2861 19.9364 18.2861 20.253 18.4814 20.4482L19.5374 21.5042C19.7304 21.6972 19.6847 22.0222 19.4275 22.1138C18.3678 22.4912 17.1664 22.2817 16.2354 21.4487C15.2186 20.5391 14.8449 19.1299 15.1381 17.8537C15.172 17.706 15.1341 17.549 15.027 17.4419L12.4871 14.902"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap='round'/>
      <path d="M8.50402 10.9426L5.96412 8.40266C5.85696 8.2955 5.69999 8.25762 5.55229 8.29156C4.27615 8.58476 2.8669 8.21102 1.95727 7.19425C1.12682 6.266 0.916106 5.06903 1.28883 4.01165C1.38034 3.75204 1.70841 3.70788 1.90036 3.90456C1.90143 3.90566 1.90219 3.90644 1.90327 3.90754C1.93085 3.93559 2.39581 4.40864 2.93212 4.96116C3.12686 5.16178 3.44831 5.16472 3.64601 4.96702L4.93634 3.67669C5.1316 3.48143 5.1316 3.16484 4.93634 2.96958L3.88037 1.91362C3.68732 1.72057 3.73307 1.39557 3.99026 1.30399C5.04997 0.926649 6.25132 1.13614 7.18236 1.96907C8.19912 2.87869 8.57287 4.28795 8.27967 5.56409C8.24573 5.71179 8.2836 5.86876 8.39077 5.97592L10.9307 8.51581"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap='round'/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.8175 4.80639L20.1645 2.39446L21.6243 3.80471L19.2261 7.1314L16.8175 4.80639Z"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'/>
      <path d="M6.99658 14.2331C7.17295 14.0567 7.45889 14.0567 7.63526 14.2331L9.62825 16.2261C9.80462 16.4025 9.80462 16.6884 9.62825 16.8648L4.90893 21.5841C4.20347 22.2896 3.05969 22.2896 2.35423 21.5841L2.27726 21.5071C1.5718 20.8017 1.5718 19.6579 2.27726 18.9524L6.99658 14.2331Z"
        stroke={iconColor}
        strokeWidth={1.5}/>
      <path d="M8.74146 15.1512L17.758 6.10345"
        stroke={iconColor}
        strokeWidth={1.5}/>
    </svg>
    
  );
};
